import { i18n } from '../../main'

const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection

function connectionStatus () {
  if (connection && connection.type === 'wifi' && connection.type === 'wimax') {
    return true
  } else {
    return confirm(i18n.t('map.checkConnection'))
  }
}

function hostReachable () {
  // Handle IE and more capable browsers
  var xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP')
  // Open new request as a HEAD to the root hostname with a random param to bust the cache
  xhr.open('HEAD', location.origin + '/?rand=' + Math.floor((1 + Math.random()) * 0x10000), false)
  // Handle response
  try {
    xhr.send()
    return (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304))
  } catch (error) {
    return false
  }
}

export { connectionStatus, hostReachable }
